<template>
  <div>
    <div class="breadcrumb">
      <span @click="navigateBack" class="cursor-pointer">所有用户</span>
      <i class="mdg-icon ico_arrow_right_grayx"></i>
      <span>二维码邀请</span>
    </div>
    <div class="card px-20 py-25">
      <div class="card-header">二维码邀请</div>
      <el-row :gutter="40">
        <el-col :span="12">
          <div class="sub-header-container">
            <div class="sub-header">
              <span>请选择添加职员的部门</span>
              <span class="multi-hint">（可多选）</span>
            </div>
            <el-button @click="showDepartmentDrawer" plain class="create-btn">
              <i class="mdg-icon ico_creatx text-primary vcenter"></i>
              <span class="vcenter">添加部门</span>
            </el-button>
          </div>
          <div class="select-container">
            <el-tree
              ref="tree" :data="departments" empty-text="暂无数据"
              node-key="id" default-expand-all show-checkbox check-strictly
              :props="{disabled: (data) => !data.end}" class="department-tree"
            >
              <div slot-scope="{data}" class="tree-node">
                <i class="mdg-icon ico_xiangmux vcenter"></i>
                <span class="node-name vcenter">{{ data.name }}</span>
              </div>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="sub-header-container">
            <div class="sub-header">
              <span>请选择添加职员的职位</span>
              <span class="multi-hint">（可多选）</span>
            </div>
            <el-button @click="showRoleDrawer" plain class="create-btn">
              <i class="mdg-icon ico_creatx text-primary vcenter"></i>
              <span class="vcenter">添加职位</span>
            </el-button>
          </div>
          <div class="select-container">
            <el-checkbox-group v-model="selectedRoles">
              <el-checkbox
                v-for="role in roles" :key="role.id"
                :label="role.id" class="checkbox"
              >
                {{ role.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <div class="my-40 text-center">
        <el-button @click="generateQrcode" type="primary" style="width:200px;">
          生成二维码
        </el-button>
      </div>
    </div>
    <transition name="el-fade-in">
      <div v-show="qrcodeDialogShown" class="qrcode-dialog">
        <i @click="closeQrcodeDialog" class="mdg-icon dialog_ico_close_blackx close-icon"></i>
        <div class="canvas-container">
          <canvas class="qrcode-canvas" ref="qrcodeCanvas"></canvas>
          <el-button @click="downloadQrcode" type="primary" style="width: 124px">另存为</el-button>
        </div>
      </div>
    </transition>
    <drawer :show.sync="departmentDrawerShown" pos="right" :close-on-click-mask="false" >
      <div class="drawer-container">
        <div class="header">添加部门</div>
        <div class="py-30 pl-20 pr-55 mt-60">
          <el-form
            :model="departmentForm" :rules="departmentFormRules"
            ref="departmentForm" label-width="80px" class="mdg-form"
          >
            <el-form-item label="上级部门" prop="parent" required>
              <department-picker
                v-model="departmentForm.parent" :departments="departments"
                :select-disabled="(data) => !!data.staff" :multi="false"
                placeholder="请选择上级部门"
              ></department-picker>
            </el-form-item>
            <el-form-item label="部门名称" prop="name">
              <el-input v-model.trim="departmentForm.name" placeholder="请输入部门名称"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input
                v-model="departmentForm.note" type="textarea" :rows="3"
                placeholder="请输入备注" resize="none"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button @click="closeDepartmentDrawer" type="default" size="small">取消</el-button>
          <el-button @click="submitDepartmentDrawer" type="primary" size="small">保存</el-button>
        </div>
      </div>
    </drawer>
    <drawer :show.sync="roleDrawerShown" pos="right" :close-on-click-mask="false" >
      <div class="drawer-container" style="width: 765px;">
        <div class="header">添加职位</div>
        <div class="form-group mt-60">
          <div class="form-group-title">职位信息</div>
          <el-form
            :model="roleForm" :rules="roleFormRules"
            ref="roleForm" label-width="80px" class="mdg-form"
          >
            <el-form-item label="职位名称" prop="name">
              <el-input
                v-model.trim="roleForm.name" placeholder="请输入职位名称" style="width:400px"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input
                v-model="roleForm.note" type="textarea" :rows="3"
                placeholder="请输入备注" resize="none" style="width:400px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="padding: 32px 24px 12px;">
          <div class="form-group-title">权限赋予</div>
          <div>          
              <div v-for="(group, i) in permissionGroups" :key="i" class="permission-group">   <!--修复用户权限中，二维码添加人员里面的添加职位不能正常使用，点击后输入不了职位同时网页会卡主 -->  
                <div class="name">{{ group.name }}</div>
                <div class="permission-list">
                  <div
                    v-for="permission in group.children"
                    :key="permission[0].id" class="inline-block"
                  >
                    <div class="permission-tree-wrapper">
                      <img :src="permission[0].logo" class="logo" alt="" />
                      <el-tree
                        :data="permission" ref="createPermissionTree"
                        node-key="id" default-expand-all show-checkbox
                        class="permission-tree" empty-text="暂无数据"
                      >
                        <div slot-scope="{data}" class="tree-node">
                          <span class="node-name vcenter">{{ data.name }}</span>
                        </div>
                      </el-tree>
                    </div>
                  </div>
                </div>
              </div>
            <!-- <div
              v-for="(group, index) in permissionGroups" :key="group.id"
              class="permission-group"
               :class="{'mr-20': index % 2 === 0}"
            >
              <div class="permission-group-wrapper">
                <img :src="group.logo" class="logo" alt="" />
                <el-tree              
                  :data="[group]" ref="createPermissionTree"
                  node-key="id" default-expand-all show-checkbox
                  class="permission-tree" empty-text="暂无数据"
                >
                  <div slot-scope="{data}" class="tree-node">
                    <span class="node-name vcenter">{{ data.name }}</span>
                  </div>
                </el-tree>
              </div>
            </div> -->
          </div>
        </div>
        <div class="footer">
          <el-button @click="closeRoleDrawer" type="default" size="small">取消</el-button>
          <el-button @click="submitRoleDrawer" type="primary" size="small">保存</el-button>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import _ from 'lodash'
import QRCode from 'qrcode'
import download from 'downloadjs'
import {
  Button, Tree, CheckboxGroup,
  Checkbox, Form, FormItem, Input,
} from 'element-ui'
import Drawer from '@/components/Drawer'
import DepartmentPicker from '@/components/DepartmentPicker'
import * as API from '@/api/staff'
import {
  getDepartmentTree,
  createSubdepartment,
} from '@/api/department'
import {
  findAllPermissionGroups,
  find as findRoles,
  create as createRole,
} from '@/api/role'

export default {
  name: 'generate-qrcode-view',
  components: {
    ElButton: Button,
    ElTree: Tree,
    ElCheckboxGroup: CheckboxGroup,
    ElCheckbox: Checkbox,
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    Drawer,
    DepartmentPicker,
  },
  data() {
    return {
      ceshi:[],
      departments: [],
      roles: [],
      selectedRoles: [],
      qrcodeDialogShown: false,
      departmentDrawerShown: false,
      departmentForm: {
        parent: [],
        name: '',
        note: '',
      },
      departmentFormRules: {
        parent: [{
          validator: (rule, value, callback) => {
            if (_.isArray(value) && value.length === 1) {
              callback()
            } else {
              callback(new Error('请选择上级部门'))
            }
          },
        }],
        name: [{ required: true, message: '请填写部门名称' }],
      },
      roleDrawerShown: false,
      roleForm: {
        name: '',
        note: '',
        permissions: [],
      },
      roleFormRules: {
        name: [{ required: true, message: '请填写职位名称' }],
      },
      permissionGroups: [],
    }
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
    })
    this.departments = await getDepartmentTree()
    this.roles = await findRoles()
    loading.close()
  },
  methods: {
    navigateBack() {
      this.$router.push({
        name: 'staff-list',
      })
    },
    showDepartmentDrawer() {
      this.departmentForm = {
        parent: [],
        name: '',
        note: '',
      }
      this.departmentDrawerShown = true
      this.$nextTick(() => {
        this.$refs.departmentForm.clearValidate()
      })
    },
    closeDepartmentDrawer() {
      this.departmentDrawerShown = false
    },
    submitDepartmentDrawer() {
      this.$refs.departmentForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        try {
          await this.$confirm('确定要添加部门吗？', '提示', {
            type: 'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
          let loading = this.$loading({
            lock: true,
            text: '加载中...',
          })
          const flag = await createSubdepartment({
            parent: this.departmentForm.parent[0].id,
            name: this.departmentForm.name,
            note: this.departmentForm.note,
          })
          loading.close()
          if (flag) {
            this.$message({
              type: 'success',
              message: '添加成功',
            })
            this.departmentDrawerShown = false
            loading = this.$loading({
              lock: true,
              text: '加载中...',
            })
            this.departments = await getDepartmentTree()
            loading.close()
          }
        } catch (e) {
          // noop
        }
      })
    },
    async showRoleDrawer() {
      this.roleForm = {
        name: '',
        note: '',
        permissions: [],
      }
      this.roleDrawerShown = true

      if (_.isEmpty(this.permissionGroups)) {
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        this.permissionGroups = await findAllPermissionGroups()
        console.log(this.permissionGroups)
        loading.close()
      }

      this.$nextTick(() => {
        this.$refs.roleForm.clearValidate()
      })
    },
    closeRoleDrawer() {
      this.roleDrawerShown = false
    },
    submitRoleDrawer() {
      this.$refs.roleForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        try {
          await this.$confirm('确定要添加职位吗？', '提示', {
            type: 'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
          let loading = this.$loading({
            lock: true,
            text: '加载中...',
          })
          const id = await createRole({
            name: this.roleForm.name,
            note: this.roleForm.note,
            permissions: this.$refs.createPermissionTree.map((tree) => {
              let keys = tree.getCheckedKeys()
              keys = keys.concat(tree.getHalfCheckedKeys())
              return keys
            }).reduce((arr, current) => arr.concat(current), []),
          })
 
          loading.close()
          if (_.isNumber(id) && id > 0) {
            this.$message({
              type: 'success',
              message: '添加成功',
            })
            this.roleDrawerShown = false
            loading = this.$loading({
              lock: true,
              text: '加载中...',
            })
            this.roles = await findRoles()
            loading.close()
          }
        } catch (e) {
          // noop
        }
      })
    },
    async generateQrcode() {
      const selectedDepartments = this.$refs.tree.getCheckedKeys()
      if (_.isEmpty(selectedDepartments)) {
        this.$message({
          type: 'error',
          message: '至少为职员选择一个部门',
        })
        return
      }
      if (_.isEmpty(this.selectedRoles)) {
        this.$message({
          type: 'error',
          message: '至少为职员选择一个职位',
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      const url = await API.generateQrcode({
        departments: selectedDepartments,
        roles: this.selectedRoles,
      })
      console.log(url) // eslint-disable-line
      loading.close()
      if (!url) {
        return
      }

      this.qrcodeDialogShown = true
      this.$nextTick(async () => {
        const loading2 = this.$loading({
          lock: true,
          text: '加载中...',
        })
        await QRCode.toCanvas(this.$refs.qrcodeCanvas, url, {
          margin: 1,
          width: 260,
        })
        loading2.close()
      })
    },
    closeQrcodeDialog() {
      this.qrcodeDialogShown = false
    },
    async downloadQrcode() {
      const dataUrl = this.$refs.qrcodeCanvas.toDataURL()
      download(dataUrl, '部门-职位二维码.png', 'image/png')
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variable.scss';

.breadcrumb {
  margin-bottom: 18px;
  font-size: 18px;
  line-height: 25px;
  font-weight: bold;
  color: #a3b4cc;
  .mdg-icon {
    margin: 0 2px;
    display: inline-block;
    vertical-align: middle;
    font-size: 20px;
  }
  span:last-child {
    color: #131d2d;
  }
}
.card {
  position: relative;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(53,129,251,0.1);
  border-radius: 2px;
}
.card-header {
  margin-bottom: 32px;
  font-size: 20px;
  font-weight: bold;
  color: #131d2d;
  line-height: 28px;
}
.sub-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.sub-header {
  position: relative;
  padding-left: 14px;
  color: #131d2d;
  line-height: 20px;
  font-weight: bold;
  &:before {
    content: ' ';
    position: absolute;
    top: 2px;
    left: 0;
    width: 4px;
    height: 16px;
    background: $primary;
  }
}
.multi-hint {
  color: #a3b4cc;
}
.create-btn {
  padding: 0 12px !important;
  .mdg-icon {
    margin-right: 6px;
    font-size: 24px;
  }
}
.select-container {
  box-sizing: border-box;
  padding: 20px;
  height: 560px;
  background: #f5f7f9;
  overflow: auto;;
}
.department-tree {
  background: transparent;
}
.tree-node {
  margin-left: -3px;
  &.is-leaf .el-checkbox {
    display: none;
  }
  .mdg-icon {
    font-size: 20px;
    color: #a3b4cc;
  }
  .node-name {
    color: #131d2d;
    margin-left: 2px;
  }
}
.checkbox {
  margin-bottom: 24px;
  margin-right: 15px;
  width: calc(25% - 15px);
  min-width: 115px;
  max-width: 170px;
}
.qrcode-dialog {
  z-index: 999;
  position: absolute;
  top: calc(50% - 274px);
  left: calc(50% - 354px);
  width: 709px;
  height: 548px;
  background: rgba(0, 0, 0, 0.6);
  .close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
  }
  .qrcode-canvas {
    display: block;
    margin: 0 auto 16px;
  }
  .canvas-container {
    position: relative;
    top: calc(50% - 156px);
    margin: 0 auto;
    text-align: center;
  }
}
.drawer-container {
  box-sizing: border-box;
  position: relative;
  padding-bottom: 57px;
  width: 560px;
  height: 100%;
  overflow: auto;
  .header {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 24px;
    color: #131d2d;
    font-size: 16px;
    font-weight: bold;
    line-height: 60px;
    background: #f5f7f9;
  }
  .footer {
    z-index: 10;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 24px;
    width: 100%;
    text-align: right;
    line-height: 57px;
    background: #f8f9fA;
  }
}
.form-group {
  padding: 32px 24px 10px;
  border-bottom: 1px solid #d3d9e2;
}
.form-group-title {
  position: relative;
  margin-bottom: 20px;
  padding-left: 14px;
  font-weight: bold;
  color: #131d2d;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 16px;
    background: $primary;
  }
}
.permission-group {
  display: inline-block;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding: 16px;
  width: 340px;
  height: 180px;
  background: #f5f7f9;
  overflow: auto;
}
.permission-group-wrapper {
  display: flex;
  .logo {
    width: 48px;
    height: 48px;
    border-radius: 2px;
    overflow: hidden;
  }
}
.permission-tree {
  flex: 1;
  height: 148px;
  background: transparent;
  overflow: auto;
}

.permission-list {
  margin-left: -10px;
  .note {
    margin-bottom: 10px;
    padding: 0 10px;
  }
}
.permission-tree-wrapper {
  display: flex;
  box-sizing: border-box;
  margin: 10px;
  // padding: 16px;
  // width: 320px;
  height: 180px;
  background: #f5f7f9;
  overflow: auto;
  .logo {
    width: 48px;
    height: 48px;
    border-radius: 2px;
    overflow: hidden;
  }
}
.permission-tree {
  flex: 1;
  height: 148px;
  background: transparent;
  overflow: auto;
}
</style>

<style lang="scss">
.permission-tree>.el-tree-node>.el-tree-node__content:first-child {
  .tree-node {
    margin-top: -2px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    line-height: 22px;
  }
}
.department-tree {
  .el-tree-node__content {
    padding: 4px 0;
  }
  .el-checkbox.is-disabled {
    display: none;
  }
}
</style>
